import {ConsultProtocolsTrackParams} from 'domain/usecases/private/consult-protocols/get-consult-protocols-track';
import {makeGetConsultProtocolsTrack} from 'main/factories/usecases/private/consult-protocols/get-protocol-details';
import {formatDateString} from 'presentation/utils';
import {DateFormatEnum} from 'presentation/constants';
import {capitalize} from '@mui/material';

export async function getProtocolsTrack(params: ConsultProtocolsTrackParams) {
	const response = await makeGetConsultProtocolsTrack().get(params);

	const formattedTimeline = response?.trilha?.map(item => ({
		dsTrilha: capitalize(item.dsTrilha.toLowerCase()),
		dtRegistro: formatDateString(
			item.dtRegistro,
			DateFormatEnum.DATE_FORMAT_12,
			DateFormatEnum.DATE_FORMAT_1,
			'às',
		),
	}));

	return {
		...response,
		trilha: formattedTimeline ?? [],
	};
}
